import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

export const tenantAuth = data => {
  return request(UrlConfig.UserWeb.UcenterControlPanelAuth, {
    method: METHODS.POST,
    data,
    timeout: 60000 * 60,
    noExtraHeader: true,
  })
}

export const controlPanelPreAuth = data => {
  return request(UrlConfig.Caas.UcenterControlPanelAuthCode, {
    method: METHODS.POST,
    data,
    timeout: 60000 * 60,
    noExtraHeader: true,
  })
}

export const controlPanelAuth = (userId, params, headers) => {
  return request(UrlConfig.Caas.GrantAuthorizationByAuthCode + '/' + userId, {
    method: METHODS.POST,
    params,
    timeout: 60000 * 60,
    headers,
    noExtraHeader: true,
  })
}

export const tenantResetInitialPassword = (data, headers) => {
  return request(UrlConfig.Caas.resetPasswordWithRequireChangePassword, {
    method: METHODS.POST,
    data,
    timeout: 60000 * 60,
    headers
  })
}

// 忘记密码

export const tenantResetPassword = data => {
  return request(UrlConfig.Caas.UcenterControlResetPassword, {
    method: METHODS.POST,
    data,
    timeout: 60000 * 60,
  })
}

export const tenantResetPasswordWithSendCode = data => {
  return request(UrlConfig.Caas.resetPasswordWithSendCode, {
    method: METHODS.POST,
    data,
    timeout: 60000 * 60,
    noExtraHeader: true,
  })
}

export const tenantResetPasswordWithCheckCode = data => {
  return request(UrlConfig.Caas.resetPasswordWithCheckCode, {
    method: METHODS.POST,
    data,
    timeout: 60000 * 60,
  })
}

// 验证码登录 - 发送验证码
export const sendLoginVerifyCode = phone => {
  return request(`${UrlConfig.Caas.SendLoginVerifyCode}/${phone}`, {
    method: METHODS.POST,
    timeout: 60000 * 60,
    noExtraHeader: true,
  })
}

// 获取身份列表
export const getUserIdentities = () => {
  return request(UrlConfig.Caas.GetUserIdentities, {
    method: METHODS.GET,
    timeout: 60000 * 60,
  })
}

// 切换身份
export const changeUserIdentity = (userIdentityId) => {
  return request(UrlConfig.Caas.ChangeUserIdentity + userIdentityId, {
    method: METHODS.POST,
    timeout: 60000 * 60,
  })
}

export const getUserIdentityPage = (options) => {
  return request(UrlConfig.Caas.GetUserIdentityPage, {
    method: METHODS.POST,
    timeout: 60000 * 60,
    ...options,
  })
}
export const getUserIdentityList = (data = {}) => {
  return request(UrlConfig.Caas.GetUserIdentityList, {
    method: METHODS.POST,
    data
  })
}
export const getTags = (data = {}) => {
  return request(UrlConfig.Caas.GetTags, {
    method: METHODS.POST,
    data
  })
}